<template>
    <ForceNewsBlockWrapper :requireCharacters="requireCharacters" :titleLabel="$t('profile.label.email')" :parentScreen="parentScreen">
        <div class="form-group row">
            <label class="control-label col-md-3 col-form-label">{{$t('profile.label.mail')}}</label>
            <div class="col-md-6">
                <input type="text"
                       class="form-control"
                       v-model="$v.input['amsCustomerDetail.email'].$model"
                       name="email"
                       required
                       maxlength="50"
                       v-remove-fullwidth-character
                       v-keep-only-character
                       @keyup="$v.$touch"
                >
                <error-messages-block :field="$v.input['amsCustomerDetail.email']">
                    <template #requiredIf>
                        {{ $t('MSG_TRS_NAF_0004_param', {param1 : $t('profile.label.email')}) }}
                    </template>
                    <template #emailValidation>
                        {{$t('profile.email.invalid')}}
                    </template>
                    <template #blackListDomainsValidation>
                        {{ $t('MSG_NAB205') }}
                    </template>
                    <template #notSameAs>
                        {{ $t('profile.update.error.email.exits') }}
                    </template>
                    <template #checkChangeToExistingMail>
                        {{ $t('profile.update.error.email.exits') }}
                    </template>
                </error-messages-block>
            </div>
        </div>
        <div class="form-group row">
            <label class="control-label col-md-3 col-form-label">{{$t('profile.label.mail_confirm')}}</label>
            <div class="col-md-6">
                <input type="text"
                       class="form-control"
                       v-model="$v.input['amsCustomerDetail.confirmEmail'].$model"
                       name="email"
                       required
                       maxlength="50"
                       v-remove-fullwidth-character
                       v-keep-only-character
                >
                <error-messages-block :field="$v.input['amsCustomerDetail.confirmEmail']">
                    <template #requiredIf>
                        {{ $t('MSG_TRS_NAF_0004_param', {param1 : $t('profile.label.email')}) }}
                    </template>
                    <template #emailValidation>
                        {{$t('profile.email.invalid')}}
                    </template>
                    <template #sameAs>
                        {{ $t('profile.error.mail_confirm.not.matching') }}
                    </template>
                </error-messages-block>
                <p style="margin-top: 5px" class="form-helper-block text-danger">
                    {{$t('profile.message.notify.change.mail' )}}
                </p>
            </div>
        </div>
        <template v-if="this.isParentScreenEditProfile">
            <div class="form-action">
                <button class="btn btn-sm btn-submit btn-success mr-2"
                        :disabled="isDisabledButtonSubmit"
                        :type="this.getButtonType()">
                    {{$t('profile.button.submit')}}
                </button>
                <button class="btn btn-default btn-cancel btn-sm"
                        type="button"
                        @click="reverseInput">
                    {{$t('profile.button.cancel')}}
                </button>
            </div>
        </template>
    </ForceNewsBlockWrapper>
</template>
<script>
    /**
     * @author HungNS
     */
    import formMixin from '@/common/mixins/form';
    import {not, requiredIf, sameAs} from 'vuelidate/lib/validators'
    import {blackListDomainsValidation, emailValidation} from '@/common/helpers/validation'

    export default {
        name: "UpdateMail",
        props: {},
        mixins: [formMixin],
        methods: {},
        validations() {
            return {
                input: {
                    'amsCustomerDetail.email': {
                        requiredIf: requiredIf(function () {
                            return this.input['amsCustomerDetail.email'] !== null
                        }),
                        emailValidation,
                        blackListDomainsValidation,
                        notSameAs: not(sameAs(function () {
                            return this.input['amsCustomerDetail.additionalEmail']
                        })),
                        checkChangeToExistingMail: function(){
                            let newMainMail = this.input['amsCustomerDetail.email'];
                            let oldMainMail = null;
                            let oldAdditionalMail = null;
                            if (this.isParentScreenForceNew){
                                oldMainMail = this.getForceNewsCustomerInfoView.email;
                                oldAdditionalMail = this.getForceNewsCustomerInfoView.additionalEmail;
                            } else {
                                oldMainMail = JSON.parse(this.masterInput)['amsCustomerDetail.email'];
                                oldAdditionalMail = JSON.parse(this.masterInput)['amsCustomerDetail.additionalEmail'];
                            }
                            if (!oldAdditionalMail){
                                return this.checkNonCaseSensitiveExistingEmail(oldMainMail, newMainMail);
                            } else {
                                return this.checkNonCaseSensitiveExistingEmail(oldMainMail, newMainMail) &&  this.checkNonCaseSensitiveExistingEmail(oldAdditionalMail, newMainMail);
                            }
                        }
                    },
                    'amsCustomerDetail.confirmEmail': {
                        requiredIf: requiredIf(function () {
                            return this.input['amsCustomerDetail.confirmEmail'] !== null
                        }),
                        emailValidation,
                        sameAs: sameAs(function () {
                            if (this.input && this.input['amsCustomerDetail.email']) {
                                return this.input['amsCustomerDetail.email'];
                            }
                        })
                    }
                }
            }
        }
    }
</script>

<style scoped>

</style>
